/* eslint-disable */
export default {
  download: 'Downloaden',
  play: 'Afspelen',
  pause: 'Pauzeren',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
